import { render, staticRenderFns } from "./Bets.vue?vue&type=template&id=0c403082&"
import script from "./Bets.vue?vue&type=script&lang=js&"
export * from "./Bets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports